import React from 'react'
import HomeOutlined from '@material-ui/icons/HomeOutlined'

export default function HomeOutlinedIcon() {

    return (
        <HomeOutlined />
    )
}